export class GetTableSignalsResponse {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "asOf",
            "baseName": "asOf",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "signals",
            "baseName": "signals",
            "type": "Array<TableSignal>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return GetTableSignalsResponse.attributeTypeMap;
    }
    constructor() {
    }
}
